import { __assign } from "tslib";
import React from 'react';
// eslint-disable-next-line no-unused-vars
import Tooltip from '@material-ui/core/Tooltip';
export var CustomTooltip = function (options) {
    return React.createElement(Tooltip, __assign({}, options));
};
//# sourceMappingURL=Tooltip.js.map